var _desc, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVouchers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "vouchers") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Canvas",
    transform: "translate(276 -250)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vouchers"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path0_fill",
    transform: "translate(-276 250)",
    fill: "#868686"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path1_fill",
    transform: "translate(-271.662 253.567)",
    fill: "#868686"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path1_fill",
    transform: "translate(-271.662 256.31)",
    fill: "#868686"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path1_fill",
    transform: "translate(-271.662 259.053)",
    fill: "#868686"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path1_fill",
    transform: "translate(-271.662 261.797)",
    fill: "#868686"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path1_fill",
    transform: "translate(-271.662 264.54)",
    fill: "#868686"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path0_fill",
    d: "M 0.394366 4.8834C 0.225352 4.8834 0.112676 4.99314 0.112676 5.15775L 0.112676 18.107L 0.112676 18.1344L 0.112676 18.1619C 0.112676 18.2167 0.140845 18.2716 0.197183 18.299L 1.38028 19.8903C 1.43662 19.9726 1.52113 20 1.60563 20C 1.69014 20 1.77465 19.9451 1.83099 19.8903L 2.8169 18.546L 3.80282 19.8903C 3.85916 19.9726 3.94366 20 4.02817 20C 4.11268 20 4.19718 19.9451 4.25352 19.8903L 5.23944 18.546L 6.22535 19.8903C 6.33803 20.0274 6.56338 20.0274 6.67606 19.8903L 7.66197 18.546L 8.64789 19.8903C 8.76056 20.0274 8.98592 20.0274 9.09859 19.8903L 10.0845 18.546L 11.0704 19.8903C 11.1268 19.9726 11.2113 20 11.2958 20C 11.3803 20 11.4648 19.9451 11.5211 19.8903L 12.507 18.546L 13.493 19.8903C 13.5493 19.9726 13.6338 20 13.7183 20C 13.8028 20 13.8873 19.9451 13.9437 19.8903L 15.1268 18.299C 15.1549 18.2716 15.1831 18.2167 15.2113 18.1619L 15.2113 18.1344L 15.2113 18.107L 15.2113 5.76132L 19.7183 5.76132C 19.8873 5.76132 20 5.65158 20 5.48697L 20 2.60631C 20 1.1797 18.7887 0 17.3239 0L 2.67606 0C 1.21127 0 1.07456e-07 1.1797 1.07456e-07 2.60631C 1.07456e-07 2.77092 0.112676 2.88066 0.28169 2.88066C 0.450704 2.88066 0.56338 2.77092 0.56338 2.60631C 0.56338 1.48148 1.52113 0.548697 2.67606 0.548697L 15.6901 0.548697C 15.0704 1.01509 14.6479 1.78326 14.6479 2.60631L 14.6479 17.9973L 13.7183 19.2593L 12.7324 17.915C 12.6197 17.7778 12.3944 17.7778 12.2817 17.915L 11.3803 19.2867L 10.3944 17.9424C 10.2817 17.8052 10.0563 17.8052 9.94366 17.9424L 8.95775 19.2867L 7.97183 17.9424C 7.85916 17.8052 7.6338 17.8052 7.52113 17.9424L 6.53521 19.2867L 5.5493 17.9424C 5.43662 17.8052 5.21127 17.8052 5.09859 17.9424L 4.05634 19.2867L 3.07042 17.9424C 3.01408 17.8601 2.92958 17.8326 2.84507 17.8326C 2.76056 17.8326 2.67606 17.8875 2.61972 17.9424L 1.6338 19.2867L 0.676056 17.9973L 0.676056 5.15775C 0.676056 5.02058 0.56338 4.8834 0.394366 4.8834ZM 15.3239 2.60631C 15.3239 1.48148 16.2817 0.548697 17.4366 0.548697C 18.5916 0.548697 19.5493 1.48148 19.5493 2.60631L 19.5493 5.21262L 15.3239 5.21262L 15.3239 2.60631Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1_fill",
    d: "M 0.28169 0.548697L 6.47887 0.548697C 6.64789 0.548697 6.76056 0.438957 6.76056 0.274348C 6.76056 0.109739 6.64789 0 6.47887 0L 0.28169 0C 0.112676 0 0 0.109739 0 0.274348C 0 0.438957 0.112676 0.548697 0.28169 0.548697Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVouchers);
export default __webpack_public_path__ + "static/media/vouchers.47e89ccfaab58104fbf2f44434cb01cc.svg";
export { ForwardRef as ReactComponent };